
import logoImg from '../assets/img/logo.png'
import signatureImg from '../assets/img/signature.jpeg' 

const _textCertificateSeniority = {
    logoImg: logoImg,
    signatureImg: signatureImg, 
    title: 'Certificado de antigüedad',
    firstText: 'IDESOFT Ltda., Rut. 76.427.327-3, certifica que don %_fullName_%, Rut. %_rut_% trabaja en esta empresa desde el %_date_admission_%, mantiene un contrato de trabajo de carácter %_type_contract_% y desempeña el cargo de %_workPosition_%.', 
    secondText: 'Se extiende el presente certificado a petición del interesado para los fines que estime convenientes.', 
    representative: 'David Chavez', 
    workPosition: '“Jefe de Área RRHH”', 
    business: 'IDESOFT S.A.'
}

export default _textCertificateSeniority